import { render, staticRenderFns } from "./stat_table.vue?vue&type=template&id=05c84b5e&scoped=true&"
import script from "./stat_table.vue?vue&type=script&lang=js&"
export * from "./stat_table.vue?vue&type=script&lang=js&"
import style0 from "./stat_table.vue?vue&type=style&index=0&id=05c84b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c84b5e",
  null
  
)

export default component.exports